<template>
  <div class="search-field">
    <input type="search"
           name="searchQuery"
           placeholder="Start Typing"
           @keyup="handleChange"
           :value="searchQuery">

    <button
        v-if="searchQuery && !isLoading"
        @click="clearSearchQuery"
        class="clear-search"
        title="Clear Search Query">&times;
    </button>

    <span class="mgt-spinner" v-if="isLoading"></span>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {wordCount} from "../../utils/wordCount";
import {useRoute, useRouter} from "vue-router";
import {CONFIG} from "../../config";

export default {
  name: "SearchField",

  props: {},

  data() {
    return {
      wordCount: wordCount(this.$store.getters['search/searchQuery'])
    };
  },

  setup() {
    const router = useRouter()
    const route = useRoute()
    return {router, route};
  },

  methods: {
    handleChange(event) {
      this.$store.dispatch('search/setSearchQuery', event.target.value)

      if (!CONFIG._has_url_hash) {
        return;
      }
      const triggerUrlChange = event.code.match(/Enter|Space/ig);

      if (this.wordCount !== wordCount(event.target.value) || triggerUrlChange) {
        this.wordCount = wordCount(event.target.value);

        this.$router.push({
          name: 'mgt',
          query: {
            ...this.$route.query,
            'mgt-query': event.target.value
          }
        });
      }
    },

    clearSearchQuery() {
      this.$store.dispatch('search/setSearchQuery', '')
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'search/isLoading',
      searchQuery: 'search/searchQuery'
    }),
  }
}
</script>

<style lang="scss" scoped>

.search-field {
  width: 100%;
  position: relative;

  .mgt-spinner {
    right: 1rem;
  }
}

.clear-search {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  cursor: pointer;
  color: #c00;
  font-size: 2rem;
  padding: 0;
  line-height: 1;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: #f0f0f0;
    border-color: #ddd;
  }
}

.search-field input[type="search"] {
  width: 100%;
  padding: 1rem;
  font-size: 1.3em;
  border: 1px solid var(--mgt-primary-color);
  border-radius: 5px;
}

</style>